export { default } from './LenderLogo';
